import * as React from "react";
import { format } from "date-fns";
import { CalendarIcon } from 'lucide-react';
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface DatePickerProps {
  date?: Date;
  onSelect?: (date: Date | undefined) => void;
  className?: string;
  displayFormat?: string;
  disabled?: (date: Date) => boolean;
  ariaLabel?: string;
}

export function DatePicker({
  date,
  onSelect,
  className,
  displayFormat = "PPP",
  disabled,
  ariaLabel,
}: DatePickerProps) {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (selectedDate: Date | undefined) => {
    onSelect?.(selectedDate);
    if (selectedDate) {
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant='datepicker'
          aria-label={ariaLabel}
          className={cn(
            "tw-w-full tw-justify-start tw-text-left tw-font-normal tw-bg-white",
            !date && "tw-text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="tw-mr-2 tw-h-4 tw-w-4" />
          {date ? format(date, displayFormat) : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="tw-w-auto tw-p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={handleSelect}
          disabled={disabled}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
